import CurrencyInput from 'react-currency-input-field';

import styled from 'styled-components';

import {
  getParagraphFontSize,
  getParagraphLetterSpacing,
  getParagraphLineHeight,
} from '~/common/components/Typography/Paragraph/styles';

export const CustomCurrencyInput = styled(CurrencyInput)`
  background-color: transparent;
  outline: none;
  border: none;
  width: 100%;
  line-height: ${getParagraphLineHeight['small']}px;
  font-size: ${getParagraphFontSize['small']}px;
  letter-spacing: ${getParagraphLetterSpacing('small')}px;
  font-weight: 400;
  color: ${({ theme }) => theme.neutral[0]};
`;
